import React, {useEffect, useState} from 'react';
import {MultiSelect} from "react-multi-select-component";

/**
 * @param label - The text that will be displayed as the name of the component.
 * @param className - Classes for the component container.
 * @param labelClassName - Classes for the label.
 * @param options - The options that will be displayed in the select.
 * @param mainValues - The values in the object for sending the form that provides useForm.
 * @param errors - The error object that is provided by useForm.
 * @param setData - The setData function that is provided by useForm. Designed to set the values in the object with the values of the form to send.
 * @param propName - The name of the property in the object with the data to send to useForm.
 * @param props - Other possible properties that will be used for the MultiSelect component. Read more about them in the "react-multi-select-component" documentation.
 */
const CustomMultiSelect = ({
                             label,
                             className,
                             labelClassName,
                             options,
                             mainValues,
                             errors = [],
                             setData,
                             propName,
                             ...props
                           }) => {

  const [selected, setSelected] = useState([]);

  const handleSelectChange = (data) => {
    setSelected(data);
    setData(propName, data.map(item => item.value));
  }

  useEffect(() => {

    if (mainValues.length > 0 && selected.length === 0) {
      setSelected(options.filter(item => mainValues.includes(item.value)));
    }
  }, []);

  return (
    <div className={className}>
      {label && (
        <label className={labelClassName ? labelClassName : 'form-label'}>
          {label}:
        </label>
      )}
      <MultiSelect
        options={options}
        value={selected}
        onChange={handleSelectChange}
        {...props}
        className={`form-multi-select ${errors.length ? 'error' : ''}`}
      />
      {errors && <div className="form-error">{errors}</div>}
    </div>
  );
};

export default CustomMultiSelect;
